import { render, staticRenderFns } from "./AllocationWorkspace.vue?vue&type=template&id=f688fece&scoped=true&"
import script from "./AllocationWorkspace.vue?vue&type=script&lang=ts&"
export * from "./AllocationWorkspace.vue?vue&type=script&lang=ts&"
import style0 from "./AllocationWorkspace.vue?vue&type=style&index=0&id=f688fece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f688fece",
  null
  
)

export default component.exports